import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { GlobalChatWidget } from '../../components/chat/GlobalChatWidget';
import { useAuthStore } from '../../store/authStore';

export function ChatPopoutPage() {
  const [searchParams] = useSearchParams();
  const contatoIdParam = searchParams.get('contatoId') || undefined;
  const user = useAuthStore((s) => s.user);
  const [isFlashing, setIsFlashing] = useState(false);

  useEffect(() => {
    document.title = 'Chat Interno — Aluno Conectado';

    let metaTheme = document.querySelector("meta[name='theme-color']");
    if (!metaTheme) {
      metaTheme = document.createElement('meta');
      metaTheme.setAttribute('name', 'theme-color');
      document.head.appendChild(metaTheme);
    }
    metaTheme.setAttribute('content', '#19072d');

    // Auto-ajuste para preencher toda a tela utilizável do monitor atual
    const maximizeToScreen = () => {
      try {
        const availL = (window.screen as any).availLeft ?? 0;
        const availT = (window.screen as any).availTop ?? 0;
        const availW = window.screen.availWidth || window.screen.width;
        const availH = window.screen.availHeight || window.screen.height;

        window.moveTo(availL, availT);
        window.resizeTo(availW, availH);
      } catch {
        // Ignora caso a política do navegador restrinja moveTo/resizeTo
      }
    };

    maximizeToScreen();
    const t1 = setTimeout(maximizeToScreen, 100);
    const t2 = setTimeout(maximizeToScreen, 300);

    // Canal de sincronismo e foco com a aba principal do dashboard
    const channel = new BroadcastChannel('ac_chat_popout_sync');

    const updateHeartbeat = () => {
      localStorage.setItem('ac_chat_popout_last_active', String(Date.now()));
    };
    updateHeartbeat();
    const heartbeatInterval = setInterval(updateHeartbeat, 2000);

    channel.onmessage = (event) => {
      if (event.data?.type === 'FOCUS_AND_FLASH' || event.data?.type === 'PING') {
        try {
          window.focus();
        } catch {
          // Ignora restrições do navegador
        }
        setIsFlashing(true);

        // Piscar título da janela/aba para chamar atenção imediata
        let toggle = false;
        const titleInterval = setInterval(() => {
          document.title = toggle ? '💬⚡ CHAT ATIVO — Aluno Conectado' : '🔔 Chat Interno';
          toggle = !toggle;
        }, 350);

        setTimeout(() => {
          clearInterval(titleInterval);
          document.title = 'Chat Interno — Aluno Conectado';
          setIsFlashing(false);
        }, 2800);
      }
    };

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearInterval(heartbeatInterval);
      localStorage.removeItem('ac_chat_popout_last_active');
      channel.close();
    };
  }, []);

  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        margin: 0,
        padding: 0,
        overflow: 'hidden',
        background: '#090d16',
        display: 'flex',
        boxShadow: isFlashing ? 'inset 0 0 0 4px #9333ea, 0 0 35px rgba(147, 51, 234, 0.85)' : 'none',
        transition: 'box-shadow 250ms ease',
      }}
    >
      <GlobalChatWidget
        isOpen={true}
        embedded={true}
        isStandalone={true}
        defaultContatoId={contatoIdParam}
        onClose={() => window.close()}
      />
    </div>
  );
}

export default ChatPopoutPage;
